<template>
  <div class="d-flex flex-column pa-6 neutral-99 rounded-card align-center">
    <span class="text-h5 font-weight-regular">{{ percentValue }}%</span>
    <span class="body-label-caption neutral-40-light--text text-center mb-1">
      <span class="dot-icon-pitch" :style="{ backgroundColor: color }"></span>
      {{ title }}
      <v-tooltip v-if="tooltip" max-width="200px" top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-on="on"
            v-bind="attrs"
            size="12"
            class="ml-1 neutral-70--text"
            style="margin-bottom: 2px"
          >
            mdi-information
          </v-icon>
        </template>
        <span>{{ tooltip }}</span>
      </v-tooltip>
    </span>
    <span
      class="body-regular-smaller neutral-40-light--text text-center mb-1 align-center"
    >
      {{ videoTimeFormatted }}
      <v-btn
        icon
        @click="openActionModal"
        style="width: 24px; height: 24px; margin-left: 2px; margin-top: -2px"
        :disabled="disabled"
      >
        <v-icon size="16" class="neutral-40-light--text"
          >mdi-pencil-outline</v-icon
        >
      </v-btn>
    </span>
  </div>
</template>

<script>
export default {
  name: 'RetentionResultCard',
  components: {},
  props: {
    title: {
      type: String,
      required: true,
    },
    percentValue: {
      type: Number,
      required: true,
    },
    videoTime: {
      type: Number,
      required: false,
    },
    color: {
      type: String,
      required: false,
    },
    tooltip: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    videoTimeFormatted() {
      const hours = Math.floor(this.videoTime / 3600)
      const minutes = Math.floor((this.videoTime % 3600) / 60)
      const seconds = this.videoTime % 60
      return `${hours.toString().padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    },
  },
  methods: {
    openActionModal() {
      this.$emit('openModal')
    },
  },
}
</script>

<style lang="scss" scoped>
.rounded-card {
  border-radius: 8px;
  height: 100%;
}
.dot-icon-pitch {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 4px;
  margin-bottom: -2px;
}
</style>
